export default "__VITE_ASSET__CYEfwqUd__"